import { UPDATE_OBJECT_SELECTED } from '../../../_redux/pareto-ads-app-redux/action/actionTypes';
import { analytics } from '../analytics';
import { createMiddleware } from '../../../../shared/redux';

export const menuMiddleware = createMiddleware({
    [UPDATE_OBJECT_SELECTED]: async (state, { objectSelected }) => {
        const { company } = state?.loggedUser?.data;
        const { team_id: teamId } = company;
        const { data } = objectSelected;
        const { type } = data;
        if (type === 'account') {
            const { client_selected: clientSelected } = objectSelected;
            const { id: accountId, ad_account: adAccount } = data;
            const { id: clientId, shared } = clientSelected;
            const { id: platformId, type: platformType } = adAccount;

            await analytics.track('account_selected', {
                accountId,
                clientId,
                platformId,
                platformType,
                teamId,
                shared,
            });
        } else if (type === 'client') {
            const { id: clientId, shared } = data;

            await analytics.track('client_selected', {
                clientId,
                teamId,
                shared,
            });
        }
    },
}, { beforeChanges: true });
